/**
 * @file CompanyBillingPage.tsx
 * @brief Company Admin → Billing: the company's plan, then its cards.
 *
 * @author DES
 * @date 19-06-2026
 * @updated 29-07-2026 — GridBlock flush payment methods
 * @updated 22-10-2026 — "View invoices" link to /company/invoices
 */

import {
  GridBand,
  GridBlock,
} from "@/features/analytics/components/GridBlock";
import { gridPageBleedClass } from "@/features/analytics/components/gridPageBleed";
import { ViewInvoicesLink } from "@/shared/billing/ViewInvoicesLink";
import { CompanyPaymentMethodsCard } from "./components/CompanyPaymentMethodsCard";
import { CompanyPlanCard } from "./components/CompanyPlanCard";

export function CompanyBillingPage() {
  return (
    <div className={gridPageBleedClass("pb-6")}>
      <GridBlock>
        <GridBand>
          <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
            <div>
              <h2 className="text-xl font-semibold tracking-tight">Billing</h2>
              <p className="mt-1 max-w-xl text-sm text-muted-foreground">
                Your company's plan and the cards it pays with. Invoices and export
                history are on the Invoices tab.
              </p>
            </div>
            <ViewInvoicesLink audience="company_admin" />
          </div>
        </GridBand>

        {/* Your plan first (plans-visible brief B, 21-10-2026). */}
        <CompanyPlanCard />
        <CompanyPaymentMethodsCard />
      </GridBlock>
    </div>
  );
}
